import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects';
import { setLoading } from 'redux/actions/Auth';
import { GET_COMPANIES_WITH_FEED_ACCESS } from 'redux/constants/Company';
import fetch, { errorHandler } from 'auth/FetchInterceptor';
import { env } from 'configs/EnvironmentConfig';
import {
  setCompaniesWithFeedAccess,
  setSelectedCompany,
} from 'redux/actions/Company';

export function* getCompaniesWithFeedAccess() {
  yield takeLatest(GET_COMPANIES_WITH_FEED_ACCESS, function* () {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'get',
          url: env.API_ENDPOINT_URL + '/company/companies-with-feed-access',
          withCredentials: true,
        });
      });

      yield put(setCompaniesWithFeedAccess(response.data));

      const currentState = yield select();
      const currentSelectedCompany = currentState.company.selectedCompany;
      if (response.data.length > 0 && !currentSelectedCompany) {
        yield put(setSelectedCompany(response.data[0].CompanyCode));
      }
    } catch (error) {
      errorHandler(error, 'Failed to fetch companies');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getCompaniesWithFeedAccess)]);
}
